"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplateUpdateDto = void 0;
const notification_template_create_dto_1 = require("./notification-template-create.dto");
const class_validator_1 = require("class-validator");
class NotificationTemplateUpdateDto extends notification_template_create_dto_1.NotificationTemplateCreateDto {
    id;
    constructor(options) {
        super(options);
    }
    getFields() {
        return ['id', ...super.getFields()];
    }
    mapFields(template) {
        return super.mapFields(template);
    }
}
exports.NotificationTemplateUpdateDto = NotificationTemplateUpdateDto;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Number)
], NotificationTemplateUpdateDto.prototype, "id", void 0);
